import { makeStyles } from "tss-react/mui"
import { Typography } from "@mui/material"
import { multiply } from "dinero.js"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { toDinero } from "../../../../../../modules/currency/currencyLib"
import { useMoney } from "../../../../../../modules/currency/useMoney"
import { OrderLineRow } from "../../../../orderLines/OrderLineRow"

import type { TakeawayCartItem } from "../takeawayTypes"

const useStyles = makeStyles()((theme) => ({
    payrollBadge: {
        display: "inline-block",
        color: theme.palette.tailwind.amber[900],
        background: theme.palette.tailwind.amber[200],
        fontWeight: 400,
        borderRadius: ".375rem",
        padding: "0 .375rem",
        whiteSpace: "nowrap",
        alignSelf: "flex-start",
    },
}))

type TakeawayCheckoutItemRowProps = Readonly<{
    item: TakeawayCartItem
    moneyFactory: ReturnType<typeof useMoney>
}>

export function TakeawayCheckoutItemRow({ item, moneyFactory }: TakeawayCheckoutItemRowProps) {
    const { classes } = useStyles()

    if (!item.product.price) return null

    const unitPrice = toDinero(item.product.price)
    const lineTotal = multiply(unitPrice, item.quantity)
    const paymentMethod = item.product.paymentDetails?.method

    return (
        <OrderLineRow
            name={item.product.name}
            quantity={item.quantity}
            unitPrice={unitPrice}
            total={lineTotal}
            moneyFactory={moneyFactory}
        >
            {paymentMethod && (
                <LocalizedStrict
                    id="takeaway-checkout-payment-hint-by-method"
                    vars={{ method: paymentMethod.toLowerCase().replace(/_/g, " ") }}
                >
                    <Typography variant="subtitle1" component="span" className={classes.payrollBadge}>
                        Paid by {paymentMethod}
                    </Typography>
                </LocalizedStrict>
            )}
        </OrderLineRow>
    )
}
